import { gql } from '@apollo/client';

export const FILTERED_FUNDER_PORTAL_TEMPLATES = gql`
  query filteredFunderPortalTemplates($input: TemplateFilterArgs!) {
    templates: filteredFunderTemplates(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          createdAt
          updatedAt
          name
          published
          submissions
          version
          createdBy {
            id
            firstName
            lastName
          }
          creator {
            id
            name
          }
          funderRespondents {
            id
            name
          }
          institutionRespondents {
            id
            name
          }
          modifiedBy {
            id
            firstName
            lastName
          }
          owner {
            id
            isFunder
            isInstitution
            isServiceProvider
            funder {
              id
              name
            }
            institution {
              id
              name
            }
            serviceProvider {
              id
              name
            }
          }
          serviceProviderRespondents {
            id
            name
          }
          tags {
            id
            name
          }
          type {
            id
            name
          }
        }
      }
    }
  }
`;
